import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { BehaviorSubject } from "rxjs";
import { UserContextService } from "./user-context.service";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  constructor(
    private http: HttpClient,
    private userContext: UserContextService
  ) {}
  public noLoggedSubject = new BehaviorSubject<boolean>(true);
  login(credentials) {
    return this.http
      .post(environment.apiUrl + "/login", credentials, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
        }),
      })
      .pipe(
        tap((_) => this.noLoggedSubject.next(false)),
        map((authResult) => {
          if (authResult && (authResult as any).Token) {
            delete (authResult as any).$type;
            const plancUser = { ...authResult };
            delete (plancUser as any).layout;
            this.userContext.siteConnexion = (plancUser as any).SiteConnexion;
            this.userContext.baseConnexion = (plancUser as any).BaseConnexion;
            this.userContext.profil = (plancUser as any).Profil;
            // console.log("planc gest ",(plancUser as any).Gestionnaire);
            
            this.userContext.userConnected = (plancUser as any).Gestionnaire;
            localStorage.setItem("plancUser", JSON.stringify(plancUser));
          }

          return authResult;
        })
      );
  }
  refresh() {
    if ((this.gestionnaire || "").length > 0) {
      this.noLoggedSubject.next(false);
    }
  }
  logout() {
    localStorage.removeItem("plancUser");
    this.noLoggedSubject.next(true);
  }
  get gestionnaire() {
    const item = JSON.parse(localStorage.getItem("plancUser"));
    return item === null ? "" : item.Gestionnaire;
  }
}
